module.exports = __webpack_public_path__ + "img/sdg_pt-pt_(4).9c579bae.png";